import * as React from 'react';
import { Fragment } from 'react';
import { Route } from 'react-router';
import Login from './components/account/Login';
import { PrivateRoute } from './components/common/PrivateRoute';
import Layout from './components/Layout';
import Timesheet from './components/pages/Timesheet';
import Settings from './components/settings/Settings';
import TimesheetEntryForm from './components/timesheet/TimesheetEntryForm';
import './custom.css';

export default () => (
    <Fragment>
        <Settings />
        <Layout>
            <PrivateRoute path='/times'>
                <Timesheet />
            </PrivateRoute>
            <PrivateRoute exact path='/'>
                <TimesheetEntryForm />
            </PrivateRoute>
            <Route path='/login' component={Login} />
        </Layout>
    </Fragment>
);
